import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';
import { useState } from 'react';

export default function TermsPage() {
  const [contactFormOpen, setContactFormOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation onOpenContactForm={() => setContactFormOpen(true)} />
      <ContactFormDialog open={contactFormOpen} onOpenChange={setContactFormOpen} />

      <div className="pt-32 pb-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="terms-page">
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Terms & Conditions
        </h1>
        <div className="text-sm text-slate-600 mb-8">Last Updated: January 2026</div>

        <div className="space-y-8 text-base leading-relaxed text-slate-700">
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              1. Agreement to Terms
            </h2>
            <p>
              Welcome to Trademark Company. These Terms and Conditions ("Terms") govern your use of our website and trademark registration services, including trademark search, federal trademark registration, copyright registration, company formation, and Amazon Brand Registry services ("Services"). By accessing or using our Services, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you may not use our Services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              2. Services Description
            </h2>
            <p>
              Trademark Company provides intellectual property services including, but not limited to:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Trademark registration services and USPTO filing assistance</li>
              <li>Comprehensive trademark search and clearance services</li>
              <li>Copyright registration for creative works and intellectual property</li>
              <li>Company formation and business registration services</li>
              <li>Amazon Brand Registry enrollment and brand protection services</li>
              <li>Trademark monitoring and enforcement support</li>
              <li>Office action responses and trademark prosecution</li>
            </ul>
            <p className="mt-4">
              While we strive to provide expert guidance and comprehensive services, we cannot guarantee specific outcomes, including USPTO approval of trademark applications. Trademark registration is ultimately subject to USPTO examination and legal requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              3. User Accounts and Responsibilities
            </h2>
            <p>
              When you create an account or use our Services, you are responsible for:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Providing accurate, complete, and current information</li>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use of your account</li>
              <li>Ensuring you have the legal right to use any trademarks or copyrights you submit for registration</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              4. Fees and Payment
            </h2>
            <p>
              Our trademark services are offered at various pricing tiers as displayed on our website. All fees are stated in U.S. Dollars and do not include USPTO filing fees unless explicitly stated. By purchasing our Services, you agree to:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Pay all fees and charges at the time of purchase</li>
              <li>Provide current, complete, and accurate payment information</li>
              <li>Pay any additional USPTO government filing fees as required</li>
              <li>Understand that our service fees are separate from government filing fees</li>
            </ul>
            <p className="mt-4">
              Refund policies vary by service package. Service fees are generally non-refundable once work has commenced, though we will work with you to address any concerns. USPTO government filing fees are non-refundable once submitted.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              5. Intellectual Property Rights
            </h2>
            <p>
              The content, features, and functionality of our website, including but not limited to text, graphics, logos, images, and software, are owned by Trademark Company and are protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, sell, or lease any part of our Services without our express written permission.
            </p>
            <p className="mt-4">
              When you submit trademark information, applications, or other materials to us for filing, you grant us a limited license to use that information solely for the purpose of providing our trademark registration services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              6. Prohibited Uses
            </h2>
            <p>You agree not to use our Services:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>For any unlawful purpose or in violation of any applicable laws</li>
              <li>To infringe upon the intellectual property rights of others</li>
              <li>To submit false, misleading, or fraudulent information in trademark applications</li>
              <li>To transmit any harmful code, viruses, or malicious software</li>
              <li>To attempt to gain unauthorized access to our systems or other users' accounts</li>
              <li>To harass, abuse, or harm another person or entity</li>
              <li>To impersonate any person or entity or falsely state your affiliation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              7. Disclaimer of Warranties
            </h2>
            <p>
              OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. We do not warrant that our Services will be uninterrupted, secure, or error-free. While we employ experienced trademark attorneys and professionals, we cannot guarantee that every trademark application will be approved by the USPTO. Trademark registration depends on many factors including USPTO examination, potential conflicts with existing marks, and compliance with trademark law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              8. Limitation of Liability
            </h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, TRADEMARK COMPANY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE OF OUR SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p className="mt-4">
              Our total liability for any claims arising from your use of our Services shall not exceed the amount you paid us for the specific service giving rise to the claim.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              9. Indemnification
            </h2>
            <p>
              You agree to indemnify, defend, and hold harmless Trademark Company, its officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses, including reasonable attorney fees, arising out of or related to: (a) your use of our Services; (b) your violation of these Terms; (c) your violation of any third-party rights, including intellectual property rights; or (d) any false or misleading information you provide.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              10. Attorney-Client Relationship
            </h2>
            <p>
              Use of our Services does not create an attorney-client relationship unless you have entered into a separate written engagement agreement with one of our trademark attorneys. General information provided on our website is for informational purposes only and does not constitute legal advice. For specific legal advice regarding your trademark matters, please consult with one of our attorneys directly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              11. Governing Law and Dispute Resolution
            </h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. Any disputes arising from these Terms or your use of our Services shall be resolved through binding arbitration in Los Angeles, California, except that either party may seek injunctive relief in court for intellectual property disputes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              12. Modifications to Terms
            </h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the updated Terms on our website and updating the "Last Updated" date. Your continued use of our Services after such modifications constitutes your acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              13. Termination
            </h2>
            <p>
              We may terminate or suspend your access to our Services immediately, without prior notice or liability, for any reason, including if you breach these Terms. Upon termination, your right to use our Services will immediately cease. We will continue to handle any pending trademark applications in accordance with professional ethics and legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              14. Severability
            </h2>
            <p>
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              15. Contact Information
            </h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <div className="mt-4 space-y-2">
              <p><strong>Trademark Company</strong></p>
              <p>19th Floors, 515 Flower St, Los Angeles, CA 90071</p>
              <p>Email: Info@trademarkcompanylogo.com</p>
              <p>Phone: +1 (123) 123-4567</p>
            </div>
            <p className="mt-6">
              By using our trademark registration services and website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
